import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enUS from './locales/en-US.json'; // পরিবর্তন এখানে
import bn from './locales/bn.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      'en-US': { // পরিবর্তন এখানে
        translation: enUS // পরিবর্তন এখানে
      },
      bn: {
        translation: bn
      }
    },
    fallbackLng: 'en-US', // পরিবর্তন এখানে
    debug: true,
    interpolation: {
      escapeValue: false,
    }
  });

export default i18n;